// InlineOrModal: a plain ReactModal, except inside the quote workspace (no pop-ups) where it opens in place.
import InlineOrModal from "../../../../core/components/InlineOrModal";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import MainAiPricing from "../../AiPricing/mainAiPricing";
import { Loading } from "../../../../components";

// Same-origin proxy on the Laravel backend — see useTradeImage.js for
// rationale (production CORS block on duckdns).
const whatappFetchUrl = "/api/integrations/daowhatsapp";

const AiModal = ({ isOpen, item = {}, hide, isOpportunityModal, hideImport = false, approveBlack = false }) => {
  const tab = "whatsapp";
  const [isLoading, setIsLoading] = useState(false);
  const [matchList, setMatchList] = useState([]);
  const [index, setIndex] = useState(0);
  const fetchData = useCallback(
    async (url, errorMessage) => {
      setIsLoading(true);
      setMatchList([]);
      try {
        const response = await axios.get(url, {
          timeout: 15000,
        });
        const matches = response?.data?.matches || [];
        setIndex(0);
        setMatchList(matches);
      } catch (error) {
        console.error("Failed to fetch WhatsApp data", errorMessage, error);
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  const fetchWhatsappData = useCallback(() => {
    const url = `${whatappFetchUrl}/matches/${item.product_id}?confidence_threshold=0.1&watch_count=all&limit=100&intent=Buy&message_id=${item.message_id}`;
    fetchData(url, "Unable to load WhatsApp matches.");
  }, [fetchData, item?.message_id, item?.product_id]);

  const fetchApprovedWhatsappData = useCallback(() => {
    const url = `${whatappFetchUrl}/approved_matches?confidence_threshold=0.5&watch_count=all&limit=100&intent=Sell&message_id=${item.message_id}`;
    fetchData(url, "Unable to load approved WhatsApp matches.");
  }, [fetchData, item?.message_id]);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    if (item?.messageStatus === "approved") {
      fetchApprovedWhatsappData();
    } else {
      fetchWhatsappData();
    }
  }, [fetchApprovedWhatsappData, fetchWhatsappData, isOpen, item?.messageStatus]);

  return (
    <InlineOrModal
      {...{
        isOpen,
        onRequestClose: hide,
      }}
      className="lm-modal-dark"
      overlayClassName="lm-modal-overlay"
    >
      <div>
        <div className="ai-pricing-view p-2 p-sm-3">
          {isLoading && <Loading text="Data Fetching..." type="loading" />}
          {!isLoading && matchList.length === 0 && (
            <div className="text-center">No matches found</div>
          )}
          {!isLoading && matchList.length > 0 && matchList[index] && (
            <MainAiPricing
              matchItem={matchList[index]}
              key={tab + index}
              productId={item.product_id}
              tab={tab}
              requestItem={item}
              isNonMatch={false}
              isOpportunityModal={isOpportunityModal}
              hideImport={hideImport}
              approveBlack={approveBlack}
            />
          )}
        </div>
      </div>
    </InlineOrModal>
  );
};

export default AiModal;
